<template>
	<div class="w-100">
		<div class="w-100 text-center py-3 mb-4 radius-8" style="background-color: #ffe7d4 !important;">
			<p class="body-2-1 mb-1">Payment expired in</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
			<!-- <p class="body-3-3-1 mb-0">Sebelum Jumat, 24 Juli 2020, 17:25</p> -->
		</div>
		<div v-if="this.$isNotEmptyV2(customer_detail)" class="p-3 radius-8 border-semi-grey mb-4">
			<div class="w-100 mb-3">
				<p class="mb-0 body-2-2-1">Guest Name</p>
				<p class="mb-0 body-2-1">{{module_page == 'RESTAURANT' ? customer_detail.name : `${customer_detail.first_name} ${$isNotEmpty(customer_detail.last_name)?customer_detail.last_name:''}`}}</p>
			</div>
			<div class="w-100 mb-3">
				<p class="mb-0 body-2-2-1">Email</p>
				<p class="mb-0 body-2-1">{{customer_detail.email}}</p>
			</div>
			<div class="w-100 mb-3 pb-3 border-b-semi-grey-dashed">
				<p class="mb-0 body-2-2-1">Phone Number</p>
				<p class="mb-0 body-2-1">{{$isNotEmpty(customer_detail.phone_number) ? customer_detail.phone_number : ''}}</p>
			</div>
			<div class="row no-gutters">
				<div class="col-6 align-self-center">
					<p class="mb-0 body-1-4">Total Payment</p>
				</div>
				<div class="col-6 align-self-center text-right">
					<p class="mb-0 body-1-4 text-green">{{totalPaymentLabel}}</p>
				</div>
				<div v-if="chargeInfo" class="col-12 mt-1 text-right">
					<PaymentChargeInfo :charge-info="chargeInfo" :base-amount-label="baseTotalLabel" />
				</div>
			</div>
		</div>
		<div class="p-3 radius-8 border-semi-grey mb-4">
			<div class="row no-gutters">
				<div class="col-9" :class="payment.pm_image != null ? 'col-9' : 'col-12'">
					<div class="pr-3">
						<p class="mb-0 body-2-2-1">{{payment.pg_company == 'DIRECT_PAYMENT' ? 'Bank Transfer' : 'Virtual Account'}}</p>
						<p class="mb-0 body-1-4">{{payment.pm_name}}</p>
					</div>
				</div>
				<div :class="module_page == 'TICKET' ? 'col-2 offset-1' : 'col-3'" v-if="payment.pm_image != null">
					<img :src="payment.pm_image" style="width: 100%; object-fit:contain;">
				</div>
				<div class="col-12 my-3">
					<div class="w-100 border-b-semi-grey-dashed">
					</div>
				</div>
				<template v-if="payment.pg_company == 'DIRECT_PAYMENT'">
					<div class="col-12 mb-3">
						<p class="mb-0 body-2-2-1">Account Holder</p>
						<p class="mb-0 body-1-4">{{payment.acc_name}}</p>
					</div>
					<div class="col-12">
						<p class="mb-0 body-2-2-1">Account Number</p>
						<p class="mb-0 body-1-4">{{payment.acc_number}} <span class="ml-3 cursor-pointer text-orange body-2-1" @click="$copyText(payment.acc_number)">Copy</span></p>
					</div>
					<div class="col-12 mt-3" v-if="$isNotEmpty(payment.swift_code)">
						<p class="mb-0 body-2-2-1">Swift Code</p>
						<p class="mb-0 body-1-4">{{payment.swift_code}}</p>
					</div>
          <div class="col-12 mt-3">
            <p class="mb-0 body-2">Total Payment</p>
            <p class="mb-0 body-1-4 text-green">{{totalPaymentLabel}}</p>
            <PaymentChargeInfo v-if="chargeInfo" :charge-info="chargeInfo" :base-amount-label="baseTotalLabel" />
          </div>
				</template>
        <template v-if="!(payment.pg_company == 'DIRECT_PAYMENT' || payment.pg_company == 'CASHLEZ')">
          <div class="col-12">
            <p class="mb-0 body-2-2-1">Virtual Account Number</p>
            <p class="mb-0 body-1-4">{{payment.va}} <span class="ml-3 cursor-pointer text-orange body-2-1" @click="$copyText(payment.va)">Copy</span></p>
          </div>
          <div class="col-12 mt-3" v-if="this.$isEmpty(customer_detail)">
            <p class="mb-0 body-2">Total Payment</p>
            <p class="mb-0 body-1-4 text-green">{{totalPaymentLabel}}</p>
            <PaymentChargeInfo v-if="chargeInfo" :charge-info="chargeInfo" :base-amount-label="baseTotalLabel" />
          </div>
        </template>
				<div class="col-12 col-md-6" v-if="payment.pg_company == 'CASHLEZ'">
					<button class="g-btn g-btn-lg g-btn g-btn-primary w-100" @click="$openLink(payment.payment_gateway_page,'_blank')">Click here to payment</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import moment from 'moment'
	import {buildTxChargeInfo} from '@/utils/index.js'
	import PaymentChargeInfo from '@/components/v2/payment/PaymentChargeInfo.vue'

	export default{
		components:{
			PaymentChargeInfo
		},
		props:{
			data:{
				type: Object
			},
			module_page:{
				type: String,
				default: 'RESTAURANT'
			},
			customer_detail:{
				type: Object,
				default: () => {}
			}
		},
		data(){
			return{
				countdown: moment(),
	      timeout: false,
	      payment: {}
			}
		},
		computed:{
			chargeInfo(){
				// only the booking engine tx-detail carries charge_* amounts
				if(this.module_page != 'HOTEL_BOOKING_ENGINE') return null
				return buildTxChargeInfo(this.data.payments)
			},
			baseTotalLabel(){
				return this.$formatCurrency(this.payment.total_bill)
			},
			// the guest pays the converted amount, so it leads and the base total becomes the secondary line
			totalPaymentLabel(){
				return this.chargeInfo ? this.chargeInfo.amountLabel : this.baseTotalLabel
			}
		},
		mounted(){
			this.setupData().then(()=>{
				this.setupCountdown()
			})
		},
		methods:{
			setupCountdown(){
				let now = moment().format("YYYY-MM-DD HH:mm:ss")
				let exp = null

				if(this.payment.pg_company == 'IPAYMU'){
					let offset_time = "+07:00" //JAKARTA
					let exp_date = moment(this.payment.expired_date).format("HH:mm:ss")
					let local_tz = moment().format("Z")
					let exp_z = moment(`${exp_date}${offset_time}`,'HH:mm:ssZ').format()
		      exp = moment.parseZone(exp_z).local().format("YYYY-MM-DD HH:mm:ss")
				} else{
					// now = this.payment.pg_company == 'JOKUL_DOKU' && !(this.module_page == 'HOTEL_UPSELLING' || this.module_page == 'TICKET') ? moment().add(1,'h').format("YYYY-MM-DD HH:mm:ss") : now
		      exp = moment(this.payment.expired_date_utc).format("YYYY-MM-DD HH:mm:ss")
				}

	      this.countdown = moment.duration(moment(exp).diff(moment(now)))

	      let looping = setInterval(() => {
	          this.countdown = this.countdown.subtract(1, 'seconds')
	        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
	          clearInterval(looping)
	          this.timeout = true
	        }
	      },1000)
			},
			setupData(){
				return new Promise(done=>{
					if(this.module_page == 'RESTAURANT'){
						this.payment = {
							pg_company: this.data.payment_channel.payment_gateway.pg_company,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							va: this.data.payment_details.payment.virtual_account_number,
							acc_name: '',
							acc_number: '',
							swift_code: '',
							payment_gateway_page: this.data.payment_details.payment.how_to_pay_page,
							expired_date: this.data.payment_details.payment.expired_date,
							expired_date_utc: this.data.payment_details.payment.expired_date_utc,
							total_bill: this.data.tx_bill_payment.total_paid
						}
					}else if(this.module_page == 'HOTEL_BOOKING_ENGINE'){
						this.payment = {
							pg_company: this.data.payment_details.bank_name,
							pm_name: this.data.payment_details.payment_method_name,
							pm_description: this.data.payment_details.payment_channel_description,
							pm_image: null,
							va: this.data.payment_details.bank_name != 'CASHLEZ' ? this.data.payment_details.virtual_account_number : '',
							acc_name: '',
							acc_number: '',
							swift_code: '',
							payment_gateway_page: '',
							expired_date: this.data.payment_details.expired_date,
							expired_date_utc: this.data.payment_details.expired_date_utc,
							total_bill: Number(this.data.payments.payment_surcharge) > 0 ? Number(this.data.payments.total_deposit) + Number(this.data.payments.payment_surcharge) : Number(this.data.payments.total_deposit)
						}
						if(this.data.payment_details.bank_name == 'JOKUL_DOKU'){
							this.payment.payment_gateway_page = this.data.payment_details.how_to_pay_page
						}else if(this.data.payment_details.bank_name == 'CASHLEZ'){
							this.payment.payment_gateway_page = this.data.payment_details.url
							this.payment.expired_date = moment(this.data.payment_details.created_date).add(1,'h')	
							this.payment.expired_date_utc = moment(this.data.payment_details.created_date).add(1,'h')	
						}
					}else if(this.module_page == 'HOTEL_UPSELLING'){
						this.payment = {
							pg_company: this.data.payment_channel.bank_name,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							va: this.data.payment_channel.bank_name == 'DIRECT_PAYMENT' ? '' : this.data.payment_details.virtual_account_number,
							acc_name: '',
							acc_number: '',
							swift_code: '',
							payment_gateway_page: this.data.payment_channel.bank_name == 'JOKUL_DOKU' ? this.data.payment_details.how_to_pay_page : '',
							expired_date: "",
							expired_date_utc: "",
							total_bill: this.data.total_paid
						}
						if(this.data.payment_channel.bank_name == 'DIRECT_PAYMENT'){
							this.payment.acc_name = this.data.payment_details.ch_ref1,
							this.payment.acc_number = this.data.payment_details.ch_ref2,
							this.payment.swift_code = this.data.payment_details.ch_ref3,
							this.payment.expired_date_utc = moment(this.data.created_at).add(this.data.payment_channel.payment_gateway.payment_validation_time,'h').utc().format()
							this.payment.expired_date = moment(this.payment.expired_date_utc).local().format()
						}else{
							this.payment.expired_date_utc = this.data.payment_details.expired_date_utc
							this.payment.expired_date = this.data.payment_details.expired_date
						}
					}else if(this.module_page == 'HOTEL_CONCIERGE' || this.module_page == 'HOTEL_RESERVATION'){
						let pg = this.data.payment_channel.payment_gateway
						let pg_res = this.module_page == 'HOTEL_CONCIERGE' ? JSON.parse(this.data.inq_resp_detail) : this.data.inq_resp_detail
						this.payment = {
							pg_company: pg.pg_company,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							va: pg.pg_company == 'DIRECT_PAYMENT' ? '' : pg_res.payment.virtual_account_number,
							acc_name: '',
							acc_number: '',
							swift_code: '',
							payment_gateway_page: pg.pg_company == 'JOKUL_DOKU' ? pg_res.payment.how_to_pay_page : '',
							expired_date: "",
							expired_date_utc: "",
							total_bill: this.data.total_paid
						}
						if(pg.pg_company == 'DIRECT_PAYMENT'){
							this.payment.acc_name = this.data.payment_channel.ch_ref1,
							this.payment.acc_number = this.data.payment_channel.ch_ref2,
							this.payment.swift_code = this.data.payment_channel.ch_ref3,
							this.payment.expired_date_utc = moment(this.data.created_at).add(this.data.payment_channel.payment_gateway.payment_validation_time,'h').utc().format()
							this.payment.expired_date = moment(pg_res.payment.expired_date_utc).local().format()
						}else{
							this.payment.expired_date_utc = pg_res.payment.expired_date_utc
							this.payment.expired_date = pg_res.payment.expired_date
						}
					}else if(this.module_page == 'TICKET'){
						this.payment = {
							pg_company: this.data.payment_channel.bank_name,
							pm_name: this.data.payment_channel.name,
							pm_description: this.data.payment_channel.description,
							pm_image: this.data.payment_channel.image_url,
							va: this.data.payment_details.virtual_account_number,
							acc_name: '',
							acc_number: '',
							swift_code: '',
							payment_gateway_page: '',
							expired_date: this.data.payment_details.expired_date,
							expired_date_utc: this.data.payment_details.expired_date_utc,
							total_bill: Number(this.data.total_payment)+Number(this.data.payment_surcharge)
						}
					}
					done()
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/general/payment/VirtualAccount.vue